// ui-button
import { NUDITY_CLASSIFICATION } from '../constants';

export function buttonAppearanceValidator(value) {
  return ['primary', 'secondary', 'tertiary', 'danger', 'delete', 'warning', 'tertiary-light'].includes(value);
}

export function buttonTypeValidator(value) {
  return ['fill', 'outline', 'blank'].includes(value);
}

export function buttonSizeValidator(value) {
  return ['normal', 'medium', 'small', 'extra-small'].includes(value);
}

export function fontWeightValidator(value) {
  return ['normal', 'light', 'medium', 'semibold', 'bold'].includes(value)
}

// ui-modal
export function modalSizeValidator(value) {
  return ['md', 'lg'].includes(value);
}

//ui-badge
export function badgeTypeValidator(value) {
  return ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark', 'promo', 'recommended', 'not-recommended', 'rejected', 'gradient', 'custom'].includes(value)
}

export function modalImagePropsValidator(value) {
  const validPositions = [
    'center',
    'top',
    'bottom',
  ];

  const hasValidSrc = value && typeof value.src === 'string';
  const hasValidObjectPosition = !value.objectPosition || validPositions.includes(value.objectPosition);

  return hasValidSrc && hasValidObjectPosition;
}

export const imagePositionValidator = (value) => {
  if (!value || typeof value !== 'string') return false;

  const keywords = ['center', 'top', 'bottom', 'left', 'right'];

  // Split by spaces and filter out empty strings
  const parts = value.trim().split(/\s+/).filter(part => part.length > 0);

  // Empty string is valid (browser default)
  if (parts.length === 0) return true;

  if (parts.length === 1) {
    // Single value: keyword, percentage, or length
    const part = parts[0];
    return keywords.includes(part) ||
      /^-?\d*\.?\d+(px|em|rem|%|vh|vw|ex|ch|cm|mm|in|pt|pc)$/.test(part) ||
      /^-?\d+(\.\d+)?%$/.test(part);
  }

  if (parts.length === 2) {
    // Two values: combinations of keywords, percentages, or lengths
    return parts.every(part =>
      keywords.includes(part) ||
      /^-?\d*\.?\d+(px|em|rem|%|vh|vw|ex|ch|cm|mm|in|pt|pc)$/.test(part) ||
      /^-?\d+(\.\d+)?%$/.test(part)
    );
  }

  // More than 2 values for background-position is invalid
  return false;
};


//editorial-elements banner
export function linkTargetValidator(value) {
  return ["_blank",  "_self",  "_parent",  "_top",  "framename"].includes(value);
}


export function isSafeNudityClassification(value) {
  return [NUDITY_CLASSIFICATION.SAFE, null].includes(value);
}

export function isHotNudityClassification(value) {
  return [NUDITY_CLASSIFICATION.HOT].includes(value);
}

export function isHardNudityClassification(value) {
  return [NUDITY_CLASSIFICATION.HARD].includes(value);
}

export function isUnidentifiedNudityClassification(value) {
  return [NUDITY_CLASSIFICATION.UNIDENTIFIED].includes(value);
}

export function isUnsafeNudityClassification(value) {
  return [NUDITY_CLASSIFICATION.UNIDENTIFIED, NUDITY_CLASSIFICATION.HARD].includes(value);
}

export function nudityClassificationValidator(value) {
  return [null, NUDITY_CLASSIFICATION.SAFE, NUDITY_CLASSIFICATION.HOT, NUDITY_CLASSIFICATION.HARD, NUDITY_CLASSIFICATION.UNIDENTIFIED].includes(value);
}
